import { z } from 'zod';
import { CursorQuery } from '../../common/pagination.js';
import { TierKey } from '../../subscription.js';
// ── members ───────────────────────────────────────────────────────────────
export const MemberSearchQuery = CursorQuery.extend({ q: z.string().trim().min(2).max(100) });
export const MemberActivity = z.object({
    recentContent: z.array(z.object({
        id: z.string(),
        type: z.string(),
        title: z.string(),
        status: z.string(),
        createdAt: z.coerce.date(),
    })),
    recentPayments: z.array(z.object({
        id: z.string(),
        kind: z.string(),
        totalMinor: z.number().int(),
        status: z.string(),
        createdAt: z.coerce.date(),
    })),
    sanctions: z.array(z.object({
        id: z.string(),
        kind: z.string(),
        reason: z.string(),
        imposedBy: z.string(),
        until: z.coerce.date().nullable(),
        active: z.boolean(),
        createdAt: z.coerce.date(),
    })),
    relationships: z.object({
        connections: z.number().int(),
        supporters: z.number().int(),
        supporting: z.number().int(),
        blocked: z.number().int(),
        communities: z.number().int(),
    }),
});
export const MemberAdminView = z.object({
    id: z.string(),
    email: z.string().nullable(),
    phone: z.string().nullable(),
    displayName: z.string().nullable(),
    tier: TierKey,
    suspendedUntil: z.coerce.date().nullable(),
    banned: z.boolean(),
    /**
     * A closed account (FR-ADM-41). Present on the row rather than only on the
     * detail view so the console cannot render a deleted member as an ordinary
     * one — a search result that looks live, for an account that cannot sign in,
     * is how an admin suspends someone who is already gone.
     */
    deleted: z.boolean(),
    deletedAt: z.coerce.date().nullable(),
    createdAt: z.coerce.date(),
    counts: z.object({
        posts: z.number().int(),
        supporters: z.number().int(),
        reportsAgainst: z.number().int(),
        sanctions: z.number().int(),
    }),
});
/**
 * The outcome of a close or restore. Reports the tombstone rather than the
 * whole member: the caller just named the account, and what it needs back is
 * whether the state changed and what is now recorded against it.
 */
export const MemberDeletionView = z.object({
    userId: z.string(),
    deleted: z.boolean(),
    deletedAt: z.coerce.date().nullable(),
    /** The admin account id that closed it — null once restored. */
    deletedBy: z.string().nullable(),
    reason: z.string().nullable(),
});
//# sourceMappingURL=schemas.js.map